<template>
  <div class="app">
    <header class="header">
      <AppHeader />
    </header>
    <main class="main">
      <router-view />
    </main>
    <footer v-if="!$store.getters['auth/isIntegration']">
      <ExperianFooter v-if="isExperian" />
      <AppFooter v-else />
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getUpdatesToShow,
  markUpdatesSeen
} from 'modules/whats-new/services/updates'

export default {
  name: 'DefaultLayout',
  components: {
    AppHeader: () => import('modules/layout/AppHeader'),
    AppFooter: () => import('modules/layout/AppFooter/AppFooter'),
    ExperianFooter: () => import('modules/layout/ExperianFooter')
  },
  computed: {
    ...mapGetters('auth', ['isUser']),
    isExperian() {
      return this.$experian
    }
  },
  data() {
    return {
      updatesToShow: []
    }
  },
  async mounted() {
    this.updatesToShow = getUpdatesToShow(3)
    if (this.isUser && this.updatesToShow.length) {
      this.openWhatsNewModal()
    }
  },
  watch: {
    isUser(newVal, oldVal) {
      if (newVal && !oldVal && this.updatesToShow.length) {
        this.openWhatsNewModal()
      }
    }
  },
  methods: {
    openWhatsNewModal() {
      this.$modal.open('whats-new/WhatsNew', {
        updates: this.updatesToShow,
        hasCloseButton: false,
        beforeClose: () => {
          const updateIds = this.updatesToShow.map(update => update.id)
          markUpdatesSeen(updateIds)
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.header
  border-top: $nav-bar-top-border
  background-color: $navbar-background-color
</style>
